<div class="desktop">
  <div class="aux-boxes">
    <div class="cards-boxes-container"
         [ngClass]="{
          'width-fix': flashPaymentService.controller.isPlaceToPayVisible && flashPaymentService.controller.isACHVisible ,
          'two-cards': (!flashPaymentService.controller.isPlaceToPayVisible && flashPaymentService.controller.isACHVisible) || (flashPaymentService.controller.isPlaceToPayVisible && !flashPaymentService.controller.isACHVisible)
        }">
      <div
        class="card-box-container"
        [ngClass]="{
          'box-active': flashPaymentService.controller.isCard,
          '': !flashPaymentService.controller.isCard
        }"
        (click)="selectForm(0)"
        *ngIf="flashPaymentService.controller.isCardVisible"
      >
        <span>
          <img
            src="../../../../assets/images/icon_tarjeta_1.png"
            alt=""
            *ngIf="!flashPaymentService.controller.isCard"
          />
          <img
            src="../../../../assets/images/icon_tarjeta_2.png"
            alt=""
            *ngIf="flashPaymentService.controller.isCard"
          />
        </span>
        <div class="card-title">Tarjeta</div>
      </div>

      <div
        class="card-box-container"
        [ngClass]="{
          'box-active': flashPaymentService.controller.isPlaceToPay,
          '': !flashPaymentService.controller.isPlaceToPay
        }"
        (click)="selectForm(2)"
        *ngIf="flashPaymentService.controller.isPlaceToPayVisible"
      >
        <span>
          <img
            class="img-fix"
            src="../../../../assets/images/icon_wallet_2.png"
            alt=""
            *ngIf="!flashPaymentService.controller.isPlaceToPay"
          />
          <img
            class="img-fix"
            src="../../../../assets/images/icon_wallet_1.png"
            alt=""
            *ngIf="flashPaymentService.controller.isPlaceToPay"
          />
        </span>
        <div class="card-title">
          Wallet
          <!--<br />(Lightbox) -->
        </div>
      </div>

      <div
        class="card-box-container"
        [ngClass]="{
          'box-active': flashPaymentService.controller.isACH,
          '': !flashPaymentService.controller.isACH
        }"
        (click)="selectForm(1)"
        *ngIf="flashPaymentService.controller.isACHVisible"
      >
        <span>
          <img
            src="../../../../assets/images/icon_ACH_1.png"
            alt=""
            *ngIf="!flashPaymentService.controller.isACH"
          />
          <img
            src="../../../../assets/images/icon_ACH_2.png"
            alt=""
            *ngIf="flashPaymentService.controller.isACH"
          />
        </span>
        <div class="card-title">ACH</div>
      </div>
    </div>
  </div>

</div>

<div class="mobile">

  <mat-carousel
  color="gray"
  maxWidth="600"
  slideHeight="150"
  slides=""
  [loop]="true"
  [hideArrows]="false"
  [hideIndicators]="true"
  [useKeyboard]="true"
  [useMouseWheel]="false"
  proportion="10"
  class="movil-2"
  [maintainAspectRatio]="false"
  [autoplay]="false"
  (change)="selectOption($event)"
  (click)="$event.preventDefault()"
>
  <mat-carousel-slide
    #matCarouselSlide2
    overlayColor="#f2f2f2"
    *ngIf="flashPaymentService.controller.isCard || showOptionList"
  >

  <div
      *ngIf="flashPaymentService.controller.isCard || showOptionList"
      class="card-box-container"
      [ngClass]="{
        'box-active': flashPaymentService.controller.isCard,
        '': !flashPaymentService.controller.isCard
      }"
    >
      <span>
        <img
          src="../../../../assets/images/icon_tarjeta_1.png"
          alt=""
          *ngIf="!flashPaymentService.controller.isCard"
        />
        <img
          src="../../../../assets/images/icon_tarjeta_2.png"
          alt=""
          *ngIf="flashPaymentService.controller.isCard"
        />
      </span>
      <div class="card-title">Tarjeta</div>
    </div>

  </mat-carousel-slide>

  <mat-carousel-slide
  #matCarouselSlide
  overlayColor="#f2f2f2"
  [hideOverlay]="false"
  *ngIf="(flashPaymentService.controller.isPlaceToPay || showOptionList )&& flashPaymentService.controller.isPlaceToPayVisible"
>
    <div
      class="card-box-container"
      *ngIf="(flashPaymentService.controller.isPlaceToPay || showOptionList )&& flashPaymentService.controller.isPlaceToPayVisible"
      [ngClass]="{
        'box-active': flashPaymentService.controller.isPlaceToPay,
        '': !flashPaymentService.controller.isPlaceToPay
      }"
    >
      <span>
        <img
          class="img-fix"
          src="../../../../assets/images/icon_wallet_2.png"
          alt=""
          *ngIf="!flashPaymentService.controller.isPlaceToPay"
        />
        <img
          class="img-fix"
          src="../../../../assets/images/icon_wallet_1.png"
          alt=""
          *ngIf="flashPaymentService.controller.isPlaceToPay"
        />
      </span>
      <div class="card-title">
        Wallet
        <!--<br />(Lightbox) -->
      </div>
    </div>

  </mat-carousel-slide>

  <mat-carousel-slide
  #matCarouselSlide
  overlayColor="#f2f2f2"
  [hideOverlay]="false"
  *ngIf="(flashPaymentService.controller.isACH || showOptionList)&& flashPaymentService.controller.isACHVisible"
>
    <div
      class="card-box-container"
      *ngIf="(flashPaymentService.controller.isACH || showOptionList)&& flashPaymentService.controller.isACHVisible"
      [ngClass]="{
        'box-active': flashPaymentService.controller.isACH,
        '': !flashPaymentService.controller.isACH
      }"
    >
      <span>
        <img
          src="../../../../assets/images/icon_ACH_1.png"
          alt=""
          *ngIf="!flashPaymentService.controller.isACH"
        />
        <img
          src="../../../../assets/images/icon_ACH_2.png"
          alt=""
          *ngIf="flashPaymentService.controller.isACH"
        />
      </span>
      <div class="card-title">ACH</div>
    </div>

  </mat-carousel-slide>

</mat-carousel>

</div>
